import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/star.png'


const _hoisted_1 = {
  class: "home-section",
  id: "vs-home-solutions"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "home-solutions-title" }, "As soluções da Obmed são projetadas para todos os tipos de necessidades.", -1)
const _hoisted_3 = { class: "home-solutions-cards" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Agende consultas, exames e muito mais.", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "home-solutions-card-new" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "star"
  }),
  /*#__PURE__*/_createTextVNode("Novidade")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Obmed+Saúde", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Auxilio Saúde", -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Financie procedimentos, exames ou cirurgias", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Em desenvolvimento")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Este recurso estará disponível em breve! ")

import { ref, watch } from "vue";
import { ObConfirmModal } from "@/libs/components";


export default /*#__PURE__*/_defineComponent({
  emits: ["select:card"],
  setup(__props, { emit: emits }) {



const selectedCard = ref<"services" | "signature" | "financing">("services");
const showDevelopModal = ref(false);

watch(selectedCard, () => {
  emits("select:card", selectedCard.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["home-solutions-card is-services", { 'is-selected': selectedCard.value === 'services' }]),
        onClick: _cache[0] || (_cache[0] = () => (selectedCard.value = 'services'))
      }, _hoisted_5, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["home-solutions-card is-signature", { 'is-selected': selectedCard.value === 'signature' }]),
        onClick: _cache[1] || (_cache[1] = () => (selectedCard.value = 'signature'))
      }, _hoisted_9, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["home-solutions-card is-financing", { 'is-selected': selectedCard.value === 'financing' }]),
        onClick: _cache[2] || (_cache[2] = () => (showDevelopModal.value = true))
      }, _hoisted_11, 2)
    ]),
    _createVNode(_unref(ObConfirmModal), {
      show: showDevelopModal.value,
      "hidden-cancel-button": "",
      "onClick:confirm": _cache[3] || (_cache[3] = ($event: any) => (showDevelopModal.value = false)),
      "onClick:background": _cache[4] || (_cache[4] = ($event: any) => (showDevelopModal.value = false))
    }, {
      title: _withCtx(() => [
        _hoisted_12
      ]),
      default: _withCtx(() => [
        _hoisted_13
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})